import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';
import angular from 'angular';
import moment from 'moment';

angular.module('cxRelations').directive('cxInvoicingVia', [
  function() {
    return {
      restrict: 'E',
      template: require('./invoicingVia.html'),
      scope: {
        relation: '=',
        disabled: '=',
      },
      bindToController: true,
      controllerAs: 'vm',
      controller: [
        '$scope',
        '$http',
        'appUrls',
        'flySvc',
        '$timeout',
        '$q',
        'dataCache',
        'resourceFactorySvc',
        'invoiceStreamNamesSvc',
        function(
          $scope,
          $http,
          appUrls,
          flySvc,
          $timeout,
          $q,
          dataCache,
          resourceFactorySvc,
          invoiceStreamNamesSvc,
        ) {
          var vm = this;

          var getInvoicedRelations = function() {
            var deferred = $q.defer();
            return $http
              .get(appUrls.api + '/api/relation/invoicingvia/invoicedRelations/preview', {
                params: {
                  id: vm.relation.id,
                },
                cancel: deferred,
              })
              .then(
                ({ data }) => {
                  vm.invoicedRelations = data.relations;
                  vm.hasMoreInvoicedRelations = data.hasMore;
                  vm.hasInvoicingViaForMainInvoiceStream =
                    vm.mainInvoiceStream &&
                    vm.invoicedRelations &&
                    vm.invoicedRelations.some(
                      x => x.invoicingViaStream.id === vm.mainInvoiceStream.id,
                    );

                  return data;
                },
                error => {
                  flySvc.error(error);
                  return '';
                },
              );
          };

          vm.$onInit = function() {
            vm.invoicedRelations = [];
            vm.showAllInvoicedRelations = false;
            vm.selectedRelation = null;
            vm.selectedRelationStreams = null;
            vm.selectedInvoiceStream = null;
            vm.mainInvoiceStream = null;
            vm.saving = false;
            vm.hasInvoicingViaForMainInvoiceStream = false;

            getInvoicedRelations();

            $scope.$watch(`vm.relation['00ac639e-027a-4589-90fa-9017873c8e5a'].value`, function(
              newValue,
            ) {
              if (
                typeof newValue === 'undefined' &&
                vm.relation &&
                typeof vm.relation['00ac639e-027a-4589-90fa-9017873c8e5a'] === 'undefined' &&
                vm.relation.crm === 0
              ) {
                resourceFactorySvc
                  .get('invoiceStream')
                  .invoiceStreams({ id: vm.relation.id }, data => {
                    if (
                      vm.relation &&
                      typeof vm.relation['00ac639e-027a-4589-90fa-9017873c8e5a'] === 'undefined'
                    ) {
                      vm.relation['00ac639e-027a-4589-90fa-9017873c8e5a'] = { value: data };
                    }
                  });
                return;
              } else if (!newValue) {
                vm.selectedRelation = null;
                vm.selectedRelationStreams = null;
                vm.selectedInvoiceStream = null;
                vm.mainInvoiceStream = null;
                return;
              }
              vm.mainInvoiceStream = newValue.find(x => !x.assignmentId);

              vm.selectedRelation = vm.mainInvoiceStream.invoicingViaRelation || null;
              vm.selectedRelationStreams = null;
              vm.selectedInvoiceStream = vm.mainInvoiceStream.invoicingViaStream || null;

              getInvoicedRelations();
            });
          };

          vm.seeAllInvoicedRelations = () => {
            vm.showAllInvoicedRelations = !vm.showAllInvoicedRelations;
          };

          vm.onShowAllInvoicedRelationsClosed = () => {
            $timeout(() => {
              vm.showAllInvoicedRelations = false;
            }, 100);
          };

          vm.save = function(relationId, invoiceStreamId) {
            if (!vm.mainInvoiceStream) return $q.error();
            vm.saving = true;
            const model = angular.copy(vm.mainInvoiceStream);

            model.invoicingViaRelation = relationId && invoiceStreamId ? { id: relationId } : null;
            model.invoicingViaStream =
              relationId && invoiceStreamId ? { id: invoiceStreamId } : null;
            model.startDate = moment
              .utc()
              .startOf('d')
              .toDate();
            model.schedule = null;

            return resourceFactorySvc
              .get('invoiceStream')
              .update(model)
              .$promise.then(
                response => {
                  flySvc.success('msgConfirmChange');
                  angular.extend(vm.mainInvoiceStream, response);
                  vm.saving = false;
                  return vm.mainInvoiceStream;
                },
                error => {
                  flySvc.error(error);
                  vm.saving = false;
                  return '';
                },
              );
          };

          vm.relationChanged = function(selectedValue) {
            if (selectedValue && !selectedValue.id) return ''; //Typed in text without selecting
            var invoiceStreamIdPromise;
            if (!selectedValue || selectedValue.id === vm.relation.id) {
              //Empty or main relation selected
              //Clear invoicing via
              invoiceStreamIdPromise = $q.when(null);
            } else {
              if (!vm.selectedRelation || selectedValue.id !== vm.selectedRelation.id) {
                //Other relation selected, select default invoiceStream
                invoiceStreamIdPromise = invoiceStreamNamesSvc
                  .get(selectedValue.id)
                  .then(streams =>
                    getFirstSelectedInvoiceStreamId(streams, selectedValue.invoiceStreamId),
                  );
              } else {
                //Same relation
                return false; // Not changed
              }
            }

            return invoiceStreamIdPromise.then(function(invoiceStreamId) {
              if (selectedValue && selectedValue.id !== vm.relation.id && !invoiceStreamId) {
                //Error, relation has no default invoiceStream!
                flySvc.warning('msgCannotSelectRelationWithoutInvoiceStreams');
                return '';
              }

              return vm.save(selectedValue?.id, invoiceStreamId).then(function(data) {
                if (!data) return data;
                vm.value = data;
                vm.selectedRelation = selectedValue;
                vm.selectedRelationStreams = null;
                return vm.getInvoiceStreams().then(streams => {
                  vm.selectedInvoiceStream = invoiceStreamId
                    ? (streams || []).find(x => x.id === invoiceStreamId)
                    : null;
                  return true;
                });
              });
            });
          };
          vm.invoiceStreamChanged = function(selectedValue) {
            var invoiceStreamId = selectedValue ? selectedValue.id : null;
            if (!invoiceStreamId && vm.selectedRelation && vm.selectedRelation.invoiceStreamId) {
              invoiceStreamId = vm.selectedRelation.invoiceStreamId; //Reset to default invoice stream
            }
            if (vm.selectedInvoiceStream && invoiceStreamId === vm.selectedInvoiceStream.id)
              return false; //Not changed

            return vm.save(vm.selectedRelation.id, invoiceStreamId).then(function(data) {
              if (!data) return data;
              vm.value = data;
              vm.selectedInvoiceStream = selectedValue;
              return true;
            });
          };
          vm.clearInvoicingVia = function() {
            return vm.save(null, null).then(function(data) {
              if (!data) return;
              vm.selectedRelation = null;
              vm.selectedRelationStreams = null;
              vm.selectedInvoiceStream = null;
            });
          };

          vm.getInvoiceStreams = () => {
            if (!vm.selectedRelation) return $q.when([]);
            if (vm.selectedRelationStreams && vm.selectedRelationStreams.length > 0)
              return $q.when(vm.selectedRelationStreams);

            //Retrieve
            var relationId = vm.selectedRelation.id;
            return invoiceStreamNamesSvc.get(relationId).then(function(streams) {
              // Ignore stale responses when the selected relation changed in the meantime
              if (!vm.selectedRelation || vm.selectedRelation.id !== relationId)
                return streams || [];
              vm.selectedRelationStreams = streams || [];
              if (vm.selectedInvoiceStream) {
                vm.selectedInvoiceStream = vm.selectedRelationStreams.find(
                  x => x.id === vm.selectedInvoiceStream.id,
                );
              }
              return vm.selectedRelationStreams;
            });
          };
        },
      ],
    };
  },
]);
